import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { sendPasswordReset } from "../../utils/firebase";

const ForgotPasswordForm = () => {
	const navigate = useNavigate();

	// State
	const [email, setEmail] = useState("");

	// Handler
	const handleSubmit = (e) => {
		e.preventDefault();
		sendPasswordReset(email, navigate);
		setEmail("");
	};

	return (
		<Form className="mt-4" onSubmit={handleSubmit}>
			<Form.Group className="mb-3">
				<Form.Label>E-mail</Form.Label>
				<Form.Control
					placeholder={"abc@email.com"}
					value={email}
					name="email"
					onChange={({ target }) => setEmail(target.value)}
					type="email"
					size="md"
				/>
			</Form.Group>

			<Form.Group className="mb-3 ">
				<Button className="w-100 authBtn" type="submit" disabled={!email}>
					SUBMIT
				</Button>
			</Form.Group>
		</Form>
	);
};

ForgotPasswordForm.propTypes = {
	layout: PropTypes.string,
};

ForgotPasswordForm.defaultProps = { layout: "simple" };

export default ForgotPasswordForm;

//
